var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m5.264 12.914.39.876a1.474 1.474 0 0 0 2.696 0l.39-.876a1.617 1.617 0 0 1 1.646-.949l.953.102a1.475 1.475 0 0 0 1.348-2.335l-.564-.776A1.62 1.62 0 0 1 11.816 8c0-.342.109-.676.31-.953l.564-.775a1.474 1.474 0 0 0-1.348-2.335l-.953.102a1.617 1.617 0 0 1-1.647-.953L8.35 2.21a1.475 1.475 0 0 0-2.697 0l-.39.876a1.617 1.617 0 0 1-1.646.953l-.956-.102a1.475 1.475 0 0 0-1.348 2.335l.564.775a1.62 1.62 0 0 1 0 1.906l-.564.775a1.474 1.474 0 0 0 1.348 2.335l.953-.102a1.622 1.622 0 0 1 1.65.953Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
  })));
};
export default SvgSettings;